function getProblemDetailsErrors(problemDetails) {
    if (problemDetails.errors) {
        const errors = [];
        for (const key in problemDetails.errors) {
            problemDetails.errors[key].forEach((message) => {
                errors.push({ message: message, field: key == "" ? undefined : key });
            });
        }
        return errors;
    }
    else if (problemDetails.detail && problemDetails.detail !== "")
        return [{ message: problemDetails.detail }];
    else if (problemDetails.title && problemDetails.title !== "")
        return [{ message: problemDetails.title }];
    return null;
}
export function getApiErrors(httpRequest) {
    try {
        const json = JSON.parse(httpRequest.responseText);
        const errors = getProblemDetailsErrors(json);
        if (errors != null)
            return errors;
    }
    catch {
        // Empty
    }
    return [{ message: httpRequest.responseText }];
}
export function getContentDispositionFileName(contentDisposition, defaultFileName) {
    const parts = contentDisposition?.split(';').map(part => part.trim()) ?? [];
    // The encoded name (filename*=UTF-8''...) keeps the characters that are not ASCII, as accented letters,
    // which the plain name only has as an unreadable fallback
    const encodedFileName = parts.find(part => part.toLowerCase().startsWith("filename*="));
    if (encodedFileName)
        return decodeURIComponent(encodedFileName.substring(encodedFileName.indexOf("''") + 2));
    const fileName = parts.find(part => part.toLowerCase().startsWith("filename="));
    if (fileName)
        return fileName.substring("filename=".length).replace(/"/g, '').trim();
    return defaultFileName;
}
export function getAxiosApiErrors(error) {
    if (error.response && error.response.data) {
        const errors = getProblemDetailsErrors(error.response.data);
        if (errors != null)
            return errors;
    }
    return [{ message: error.message }];
}
